import { noDataFound } from "../../../CommonMethhods/CommonMethods";
import Loader from "../../../Components/Common/Loader";

const columns = [
  { title: "Sr. No", dataIndex: "SrNo" },
  { title: "Accrual Date", dataIndex: "AsOnDate" },
  { title: "Client Code", dataIndex: "ClientCode" },
  { title: "Client Name", dataIndex: "ClientName" },
  { title: "Trading Account No", dataIndex: "TradingAccountNo" },
  { title: "DP Account No", dataIndex: "DP_ID" },
  { title: "Branch", dataIndex: "Branch" },
  { title: "RM Name", dataIndex: "RMName" },
  { title: "Charge Amount", dataIndex: "TotalAccruedCharges" },
];

const ReportTable = ({ loading, dataSource, error, lastRowRef }) => {
  return (
    <div className="accrual-report__table">
      <table className={`w-100 ${error ? "h-100" : ""}`}>
        <thead>
          <tr>
            {columns.map((col) => {
              return (
                <th key={col.title} scope="col">
                  {col.title}
                </th>
              );
            })}
          </tr>
        </thead>

        <tbody>
          {error && (
            <tr>
              <td colSpan={columns.length} className="text-center">
                {noDataFound(error, { position: "static", transform: "none" })}
              </td>
            </tr>
          )}

          {!error && (
            <>
              {dataSource?.map((row, index) => (
                <tr
                  key={row.SrNo}
                  ref={index === dataSource.length - 1 ? lastRowRef : null}
                >
                  {columns.map((col) => (
                    <td key={col.dataIndex}>{row[col.dataIndex] ?? "-"}</td>
                  ))}
                </tr>
              ))}
            </>
          )}

          {loading && !error && (
            <tr>
              <td colSpan={columns.length}>
                <div className="accrual-report__loader">
                  <Loader />
                </div>
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default ReportTable;
